import React from "react";
import { CheckCircle2 } from "lucide-react";

function GuideTextList({ items = [], iconClassName = "text-indigo-600" }) {
    if (!items.length) return null;

    return (
        <ul className="space-y-3">
            {items.map((item, index) => (
                <li
                    key={`${item}-${index}`}
                    className="flex min-w-0 gap-3 text-sm text-slate-600"
                >
                    <CheckCircle2
                        size={17}
                        className={`mt-0.5 shrink-0 ${iconClassName}`}
                        aria-hidden="true"
                    />
                    <span className="min-w-0 leading-6">{item}</span>
                </li>
            ))}
        </ul>
    );
}

export default GuideTextList;
